"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormCategory = void 0;
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
var FormCategory = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var categories = ra_fetch_1.useApi('backend').index('categories')[0];
    return react_1.default.createElement(storybook_1.Forms.Select, { name: 'category_id', value: value, onChange: onChange },
        react_1.default.createElement("option", null, "Kies een categorie"),
        categories.data.map(function (category) {
            return react_1.default.createElement("option", { key: category.id, value: category.id }, category.label);
        }));
};
exports.FormCategory = FormCategory;
